import { createContractClient } from './lib/api-client';
import { preferencesRoutes } from '@contracts/account/preferences';

export const preferencesApi = createContractClient(preferencesRoutes);
